import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { BehaviorSubject, debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';
import { AddressBookControllerGetAll$Params } from 'src/app/api/fn/address-book/address-book-controller-get-all';
import { RegistryControllerGetAll$Params } from 'src/app/api/fn/registry/registry-controller-get-all';
import { AddressBookItem, RegistryItem } from 'src/app/api/models';
import { AddressBookService, RegistryService } from 'src/app/api/services';
import { ModalAddressBookFormComponent } from '../modal-address-book-form/modal-address-book-form.component';

@Component({
  selector: 'app-modal-address-book-picker',
  templateUrl: './modal-address-book-picker.component.html',
  styleUrls: ['./modal-address-book-picker.component.scss'],
})
export class ModalAddressBookPickerComponent {
  @ViewChild('keywordFilter') keywordFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('dt1') dt1?: Table;

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];

  question_title: string;
  pickerType?: string;
  registry_id?: number;
  loading = false;
  totalRecords = 0;
  addresses: AddressBookItem[] = [];
  chosenAddresses: AddressBookItem[] = [];
  selectedAddresses: AddressBookItem[] = [];
  selectedAddressBookControl = new FormControl<AddressBookItem | null>(null);
  autocompleteRegs$ = new BehaviorSubject<string>('');
  suggestedRegs: RegistryItem[] = [];
  regFilterCtrl = new FormControl<RegistryItem | undefined>(undefined);
  initialRegistryItem?: RegistryItem;
  addressBookFormModal?: DynamicDialogRef;
  contactId?: number;
  createEdit = false;
  canCreateNew = true;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private regService: RegistryService,
    private contactService: AddressBookService
  ) {
    this.question_title = config.data.question_title;
    this.pickerType = config.data.pickerType;
    this.registry_id = config.data.registry_id;
    this.canCreateNew = config.data.canCreateNew ?? true;

    // this.chosenAddresses = config.data.chosenAddresses ?? [];
    // this.selectedAddresses = [...this.chosenAddresses];
    const chosen = config.data.chosenAddresses;

    this.chosenAddresses = Array.isArray(chosen) ? chosen : chosen ? [chosen] : [];

    this.selectedAddresses = [...this.chosenAddresses];
  }

  ngOnInit() {
    if (this.registry_id) {
      this.loadInitialRegistry(this.registry_id);
    }

    this.autocompleteRegs$
      .pipe(
        debounceTime(300),

        switchMap(query =>
          query
            ? this.regService.registryControllerGetAll({
                limit: 10,
                skip: 0,
                query,
              })
            : of({ data: { list: [] } })
        )
      )
      .subscribe(res => (this.suggestedRegs = res.data.list));
  }

  loadInitialRegistry(id: number) {
    this.regService.registryControllerGetOne({ id }).subscribe({
      next: res => {
        this.initialRegistryItem = res.data;
        if (this.initialRegistryItem) {
          this.regFilterCtrl.setValue(this.initialRegistryItem);
          this.regFilterCtrl.disable();
        }
        this.loadAddresses(this.dt1!.createLazyLoadMetadata());
      },
      error: () => this.loadAddresses(this.dt1!.createLazyLoadMetadata()),
    });
  }

  filterRegs(event: AutoCompleteCompleteEvent) {
    this.autocompleteRegs$.next(event.query);
  }

  loadAddresses(event: TableLazyLoadEvent) {
    this.loading = true;

    const params: AddressBookControllerGetAll$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      registry_id: this.regFilterCtrl.value?.id ?? this.registry_id,
      query: event.globalFilter?.[0] || undefined,
    };

    this.contactService.addressBookControllerGetAll(params).subscribe(res => {
      this.addresses = res.data.list;
      this.totalRecords = res.data.count;
      this.loading = false;

      if (this.selectedAddresses.length) {
        const selectedIds = new Set(this.selectedAddresses.map(a => a.id));
        this.selectedAddresses = this.addresses.filter(a => selectedIds.has(a.id));
      }

      if (this.pickerType === 'radio' && this.selectedAddresses.length) {
        this.selectedAddressBookControl.setValue(this.selectedAddresses[0]);
      }
    });
  }

  openFormAddressBookModal(contactId?: number) {
    this.contactId = contactId;
    this.createEdit = true;
    // this.addressBookFormModal = this.dialogService.open(
    //   ModalAddressBookFormComponent,
    //   {
    //     header: 'Crea / modifica contatto',
    //     width: '70%',
    //     data: {
    //       registry_end_customer_contact_id: contactId,
    //       registry_end_customer_id: this.registry_id,
    //     },
    //   }
    // );

    // this.addressBookFormModal.onClose.subscribe(updated => {
    //   if (!updated) return;

    //   const idx = this.selectedAddresses.findIndex(a => a.id === updated.id);

    //   if (idx !== -1) {
    //     this.selectedAddresses = [
    //       ...this.selectedAddresses.slice(0, idx),
    //       updated,
    //       ...this.selectedAddresses.slice(idx + 1),
    //     ];
    //   }

    //   // ricarica dati dal backend
    //   this.loadAddresses(this.dt1!.createLazyLoadMetadata());
    // });
  }

  formSubmitted($event?: AddressBookItem) {
    this.createEdit = false;
    if (!$event) {
      return;
    }
    const idx = this.selectedAddresses.findIndex(a => a.id === $event.id);

    if (idx !== -1) {
      this.selectedAddresses = [
        ...this.selectedAddresses.slice(0, idx),
        $event,
        ...this.selectedAddresses.slice(idx + 1),
      ];
    }

    // ricarica dati dal backend
    this.loadAddresses(this.dt1!.createLazyLoadMetadata());
  }

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({
      value:
        this.pickerType === 'radio'
          ? this.selectedAddressBookControl.value
          : this.selectedAddresses,
    });
  }
}
